import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { api } from '../Api';
import { Store } from '../Store';

// OTP balance indicator for admins. Turns red and warns when the balance drops
// below the configured threshold. `compact` renders a small pill for the sidebar.
export default function OtpBalanceBadge({ compact = false }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await axios.get(api + '/api/developer/balance', {
          headers: { Authorization: `Bearer ${userInfo?.token}` },
        });
        if (active) setInfo(data);
      } catch {
        /* balance is a non-critical widget — stay silent on failure */
      }
    };
    load();
    return () => { active = false; };
  }, [userInfo]);

  if (!info) return null;
  const low = info.low;

  if (compact) {
    return (
      <a
        href="/#/admin/otp-history"
        title={low ? `Low OTP balance — below ৳${info.lowBalanceThreshold}` : 'OTP balance'}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6,
          textDecoration: 'none', width: '90%', margin: '10px auto 4px',
          borderRadius: 10, padding: '8px 12px',
          border: `1px solid ${low ? '#fecaca' : '#a7f3d0'}`,
          background: low ? '#fee2e2' : '#dcfce7',
          color: low ? '#991b1b' : '#065f46',
          boxShadow: low ? '0 0 0 3px rgba(239,68,68,0.15)' : 'none',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 800, fontSize: 12 }}>
          <i className={`fa ${low ? 'fa-exclamation-triangle' : 'fa-shield'}`} /> OTP
        </span>
        <strong style={{ fontSize: 14 }}>৳{Number(info.balanceBdt).toFixed(2)}</strong>
      </a>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        borderRadius: 12,
        padding: '12px 18px',
        margin: '0 auto 18px',
        maxWidth: 520,
        border: `1px solid ${low ? '#fecaca' : '#a7f3d0'}`,
        background: low ? '#fef2f2' : '#ecfdf5',
        color: low ? '#991b1b' : '#065f46',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <i className={`fa ${low ? 'fa-exclamation-triangle' : 'fa-shield'}`} style={{ fontSize: 20 }} />
        <div>
          <div style={{ fontSize: 12, opacity: 0.85, fontWeight: 700, textTransform: 'uppercase' }}>OTP Balance</div>
          <div style={{ fontSize: 22, fontWeight: 900, lineHeight: 1 }}>৳ {Number(info.balanceBdt).toFixed(2)}</div>
        </div>
      </div>
      {low && (
        <div style={{ fontSize: 12, fontWeight: 700, textAlign: 'right' }}>
          Low balance!<br />
          <span style={{ fontWeight: 500 }}>Below ৳{info.lowBalanceThreshold}. Top up in /julkarnine.</span>
        </div>
      )}
    </div>
  );
}
